var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 369.3 548.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#37a6d7;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.65,0C82.67,0,0,82.67,0,184.65S184.65,548.54,184.65,548.54,369.3,286.63,369.3,184.65,286.63,0,184.65,0Zm0,284.65a100,100,0,1,1,100-100A100,100,0,0,1,184.65,284.65Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 184.65,
    cy: 183.27,
    r: 100
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlue);
export default __webpack_public_path__ + "static/media/Blue.41fb15ad82495d7767a73f363137edf3.svg";
export { ForwardRef as ReactComponent };